import { render, staticRenderFns } from "./guide-download-img.vue?vue&type=template&id=54aa939b&scoped=true&"
import script from "./guide-download-img.vue?vue&type=script&lang=ts&"
export * from "./guide-download-img.vue?vue&type=script&lang=ts&"
import style0 from "./guide-download-img.vue?vue&type=style&index=0&id=54aa939b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa939b",
  null
  
)

export default component.exports